import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { CoolDialogService } from '@angular-cool/dialogs';

interface PendingJob {
  execution_name: string;
  job_data: {
    job_type: string;
    image_id: number | null;
    chapter_id: number | null;
    started_at: string;
  };
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  full_name: any;
  email_address: any;
  pendingJobsCount: number = 0;
  pendingJobs: PendingJob[] = [];
  showPendingJobsModal: boolean = false;
  isLoadingPendingJobs: boolean = true;
  private refreshInterval: any;

  popoverTitle = 'Popover title';
  popoverMessage = 'Popover description';
  confirmClicked = false;
  cancelClicked = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private apiService: ApiService,
    private dataService: DataService,
    private _dialogsService: CoolDialogService,
  ) { }

  ngOnInit(): void {
    this.full_name = this.dataService.getValue('full_name');
    this.email_address = this.dataService.getValue('email_address');
    this.loadPendingJobs();

    // Start automatic refresh every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.loadPendingJobs();
    }, 60000); // 30 seconds
  }

  ngOnDestroy(): void {
    // Clean up the interval when component is destroyed
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  toggleSidebar() {
    this.dataService.toggleSidebarVisibility();
  }

  async logout() {

    const result = await this._dialogsService.showDialog({
      titleText: 'Logout',
      questionText: `Are you sure you want to logout?`,
      confirmActionButtonText: 'Yes',
      cancelActionButtonText: 'No',
      confirmActionButtonColor: 'warn',
    });

    if (result.isConfirmed) {
      await this.dataService.logoutUser();
    }

  }
  chnagePassword() {
    let roleId = localStorage.getItem('roleId');
    if (roleId == '1'||roleId == '2') {
      this.router.navigate(['/admin/change-password']);
    } else {
      this.router.navigate(['/publisher/change-password']);
    }
  }

  /**
   * Loads pending jobs from the API
   */
  loadPendingJobs(): void {
    this.isLoadingPendingJobs = true;

    this.apiService.getAPIV3('/admin/current-pending-jobs').subscribe(
      (response: any) => {
        if (response.statusCode === 200 && response.result) {
          this.pendingJobs = response.result.pending_jobs || [];
          this.pendingJobsCount = this.pendingJobs.length;
        } else {
          this.pendingJobs = [];
          this.pendingJobsCount = 0;
        }
        this.isLoadingPendingJobs = false;
      },
      (error) => {
        console.error('Error loading pending jobs:', error);
        this.pendingJobs = [];
        this.pendingJobsCount = 0;
        this.isLoadingPendingJobs = false;
      }
    );
  }

  /**
   * Opens the pending jobs modal
   */
  openPendingJobsModal(): void {
    this.showPendingJobsModal = true;
  }

  /**
   * Closes the pending jobs modal
   */
  closePendingJobsModal(): void {
    this.showPendingJobsModal = false;
  }

  /**
   * Formats date for display
   */
  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  }

}
